<template>
    <div>
        <app-tabela
            idTabela="tblMensEnviadas"
            :itens="mensagens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
        >
            <template slot="acoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Visualizar"
                        @click.stop="visualizarMensagem(data.mensagemId)"
                    ></i>
                </span>
            </template>
        </app-tabela>
    </div>
</template>

<script>
export default {
	props: {
		mensagens: {
			type: Array,
			default: () => []
		}
	},

	components: {},

	data() {
		return {
			campos: [
				// {
				// 	key: 'criadaPor',
				// 	label: 'Criada por',
				// 	sortable: true,
				// 	filterable: true
				// },
				{
					key: 'enviadaPor',
					label: 'Enviada por',
					sortable: true,
					filterable: true
				},
				{
					key: 'assunto',
					label: 'Assunto',
					sortable: true,
					filterable: true
				},
				{
					key: 'dataCadastro',
					label: 'Criada em',
					sortable: true,
					type: 'datetime'
				},
				{
					key: 'dataEnvio',
					label: 'Enviada em',
					sortable: true,
					type: 'datetime'
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 10
		}
	},

	methods: {
		visualizarMensagem(id) {
			this.$router.push({
				name: 'Mensagens_Detalhar',
				params: {
					mensagemId: id
				}
			})
		}
	},

	created() {},

	computed: {},

	watch: {}
}
</script>
